// extracted by mini-css-extract-plugin
export default {"container":"Support_container__Plp0b","form":"Support_form__zA3kF","width":"Support_width__PmiTw"};